import { createContext } from 'react';

import { FinancialInfoProps } from 'components/modals/AssignmentDataModal/FinancialInfo';
import { AssignmentCreationTypeEnum } from 'components/modals/AssignmentDataModal/enum';

export type FinancialSchedulerType = Pick<
  FinancialInfoProps,
  | 'predefinedFinancialSchedulerValues'
  | 'workSiteWorkLocation'
  | 'w2InfoByWorkSiteWorkLocation'
  | 'mspOrVmsOverviewInfo'
> & {
  isW2Assignment?: boolean;
  isAdmin?: boolean;
  isViewDTBillRateDtPayRateFields?: boolean;
  assignmentCreationType?: AssignmentCreationTypeEnum;
  isRehireWithNewCustomer?: boolean;
};

const initialFinancialSchedulerContext: FinancialSchedulerType = {
  predefinedFinancialSchedulerValues: undefined,
  workSiteWorkLocation: null,
  w2InfoByWorkSiteWorkLocation: undefined,
  isW2Assignment: undefined,
  isAdmin: undefined,
  isViewDTBillRateDtPayRateFields: undefined,
  mspOrVmsOverviewInfo: undefined,
  assignmentCreationType: undefined,
  isRehireWithNewCustomer: undefined,
};

const FinancialSchedulerContext = createContext(
  initialFinancialSchedulerContext,
);

export default FinancialSchedulerContext;
